"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HEADER_SESSION_CREATED = exports.HEADER_CSRF_ERROR = exports.HEADER_PUBLIC_DATA_TOKEN = exports.COOKIE_CSRF_TOKEN = exports.COOKIE_ANONYMOUS_SESSION_TOKEN = exports.LOCALSTORAGE_PUBLIC_DATA_TOKEN = exports.COOKIE_PUBLIC_DATA_TOKEN = exports.LOCALSTORAGE_CSRF_TOKEN = exports.SESSION_TYPE_ANONYMOUS_JWT = exports.HANDLE_SEPARATOR = exports.SESSION_TOKEN_VERSION_0 = exports.TOKEN_SEPARATOR = exports.SESSION_TYPE_OPAQUE_TOKEN_SIMPLE = exports.LOCALSTORAGE_PREFIX = exports.COOKIE_REFRESH_TOKEN = exports.COOKIE_SESSION_TOKEN = exports.HEADER_CSRF = void 0;
const TOKEN_SEPARATOR = ';';
exports.TOKEN_SEPARATOR = TOKEN_SEPARATOR;
const HANDLE_SEPARATOR = ':';
exports.HANDLE_SEPARATOR = HANDLE_SEPARATOR;
const SESSION_TYPE_OPAQUE_TOKEN_SIMPLE = 'ots';
exports.SESSION_TYPE_OPAQUE_TOKEN_SIMPLE = SESSION_TYPE_OPAQUE_TOKEN_SIMPLE;
const SESSION_TYPE_ANONYMOUS_JWT = 'ajwt';
exports.SESSION_TYPE_ANONYMOUS_JWT = SESSION_TYPE_ANONYMOUS_JWT;
const SESSION_TOKEN_VERSION_0 = 'v0';
exports.SESSION_TOKEN_VERSION_0 = SESSION_TOKEN_VERSION_0;
const prefix = ()=>{
    if (!process.env.__BLITZ_SESSION_COOKIE_PREFIX) {
        throw new Error('Internal Blitz Error: process.env.__BLITZ_SESSION_COOKIE_PREFIX is not set');
    }
    return process.env.__BLITZ_SESSION_COOKIE_PREFIX;
};
const COOKIE_ANONYMOUS_SESSION_TOKEN = ()=>`${prefix()}_sAnonymousSessionToken`
;
exports.COOKIE_ANONYMOUS_SESSION_TOKEN = COOKIE_ANONYMOUS_SESSION_TOKEN;
const COOKIE_SESSION_TOKEN = ()=>`${prefix()}_sSessionToken`
;
exports.COOKIE_SESSION_TOKEN = COOKIE_SESSION_TOKEN;
const COOKIE_REFRESH_TOKEN = ()=>`${prefix()}_sIdRefreshToken`
;
exports.COOKIE_REFRESH_TOKEN = COOKIE_REFRESH_TOKEN;
const COOKIE_CSRF_TOKEN = ()=>`${prefix()}_sAntiCsrfToken`
;
exports.COOKIE_CSRF_TOKEN = COOKIE_CSRF_TOKEN;
const COOKIE_PUBLIC_DATA_TOKEN = ()=>`${prefix()}_sPublicDataToken`
;
exports.COOKIE_PUBLIC_DATA_TOKEN = COOKIE_PUBLIC_DATA_TOKEN;
const HEADER_CSRF = 'anti-csrf';
exports.HEADER_CSRF = HEADER_CSRF;
const HEADER_PUBLIC_DATA_TOKEN = 'public-data-token';
exports.HEADER_PUBLIC_DATA_TOKEN = HEADER_PUBLIC_DATA_TOKEN;
const HEADER_SESSION_CREATED = 'session-created';
exports.HEADER_SESSION_CREATED = HEADER_SESSION_CREATED;
const HEADER_CSRF_ERROR = 'csrf-error';
exports.HEADER_CSRF_ERROR = HEADER_CSRF_ERROR;
const LOCALSTORAGE_PREFIX = '_blitz-';
exports.LOCALSTORAGE_PREFIX = LOCALSTORAGE_PREFIX;
const LOCALSTORAGE_CSRF_TOKEN = ()=>`${prefix()}_sAntiCsrfToken`
;
exports.LOCALSTORAGE_CSRF_TOKEN = LOCALSTORAGE_CSRF_TOKEN;
const LOCALSTORAGE_PUBLIC_DATA_TOKEN = ()=>`${prefix()}_sPublicDataToken`
;
exports.LOCALSTORAGE_PUBLIC_DATA_TOKEN = LOCALSTORAGE_PUBLIC_DATA_TOKEN;

//# sourceMappingURL=constants.js.map